module.exports = "pegasus/assets/tech/safari/107.png";